import { Directive, Inject, Input, OnInit } from 'angular-ts-decorators';

@Directive({
  selector: '[fadeOutOnSrcChange]',
})
export class FadeOutOnSrcChangeDirective implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$element'];

  @Input('@') public fadeOutOnSrcChangeSrc?: string;
  @Input('@') public src?: string;

  constructor(@Inject('$element') private $element: JQLite) { }

  public ngOnInit(): void {
    const callback: MutationCallback = (mutationList: MutationRecord[]): void => {
      for (const mutation of mutationList) {
        const target: HTMLImageElement = mutation.target as HTMLImageElement;

        target.classList.remove('lazy-loaded');
        target.src = '/components/design/content/blank.png';
        setTimeout((): void => {
          target.dataset.src = this.fadeOutOnSrcChangeSrc;
          (this.$element as any).lazyLoadXT();
          window.scrollTo(window.scrollX || window.pageXOffset, (window.scrollY || window.pageYOffset) - 1);
          window.scrollTo(window.scrollX || window.pageXOffset, (window.scrollY || window.pageYOffset) + 1);
        }, 250);
      }
    };

    const observer: MutationObserver = new MutationObserver(callback);
    observer.observe(this.$element[0], {
      attributeFilter: ['fade-out-on-src-change-src'],
      attributes: true,
    } as MutationObserverInit);
  }
}
